<div class="sparkline" [hidden]="!hasData" #sparklineElem></div>
<div class="sparkline-no-data" [hidden]="hasData">---</div>
